export default __webpack_public_path__ + "static/media/icon_close.dccb078f.svg";